// http://javascriptkit.com/script/script2/css3analogclock.shtml

export default function LiveClock() {

  var hands = $('.js-live-clock div.hand');

  function updateClock() {

    var current        = new Date();
    var hourAsDegree   = ( current.getHours() + current.getMinutes()/60 ) / 12 * 360;
    var minuteAsDegree = current.getMinutes() / 60 * 360;
    var secondAsDegree = ( current.getSeconds() + current.getMilliseconds()/1000 ) /60 * 360;

    hands.filter('.hour').css({transform: 'rotate(' + hourAsDegree + 'deg)' });
    hands.filter('.minute').css({transform: 'rotate(' + minuteAsDegree + 'deg)' });
    hands.filter('.second').css({transform: 'rotate(' + secondAsDegree + 'deg)' });

    requestAnimationFrame(updateClock);

  }

  requestAnimationFrame(updateClock);

}
